import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import type { ProductCarouselItem, CardConfig } from 'components/buy';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';

export const PhotonPrice: Record<ShopifyStore, number> = {
  [ShopifyStore.US]: 249.0,
  [ShopifyStore.ROW]: 249.0,
  [ShopifyStore.GB]: 219.0,
  [ShopifyStore.EU]: 259.0,
  [ShopifyStore.AE]: 919.0,
  [ShopifyStore.IN]: 24999.0,
  [ShopifyStore.MX]: 4999.0,
  [ShopifyStore.SA]: 1079.0,
  [ShopifyStore.ZA]: 4799.0,
  [ShopifyStore.AU]: 389.0,
  [ShopifyStore.CA]: 349.0,
  [ShopifyStore.JP]: 39800.0,
};

export const PHOTON_SHIPPING_COPY = 'Shipping July 30th onwards';

export const PhotonDispatchDates: Record<ShopifyStore, string> = {
  [ShopifyStore.US]: PHOTON_SHIPPING_COPY,
  [ShopifyStore.ROW]: PHOTON_SHIPPING_COPY,
  [ShopifyStore.GB]: PHOTON_SHIPPING_COPY,
  [ShopifyStore.EU]: PHOTON_SHIPPING_COPY,
  [ShopifyStore.AE]: PHOTON_SHIPPING_COPY,
  [ShopifyStore.IN]: PHOTON_SHIPPING_COPY,
  [ShopifyStore.MX]: PHOTON_SHIPPING_COPY,
  [ShopifyStore.SA]: PHOTON_SHIPPING_COPY,
  [ShopifyStore.ZA]: PHOTON_SHIPPING_COPY,
  [ShopifyStore.AU]: PHOTON_SHIPPING_COPY,
  [ShopifyStore.CA]: PHOTON_SHIPPING_COPY,
  [ShopifyStore.JP]: PHOTON_SHIPPING_COPY,
};

const VARIANTS = {
  ultrahumanUS: 'gid://shopify/ProductVariant/44626309578812',
  ultrahumanEuUk: 'gid://shopify/ProductVariant/57772399362422',
  ultrahumanStore: 'gid://shopify/ProductVariant/44965191090246',
  ultrahumanUae: 'gid://shopify/ProductVariant/62840624021875',
  stelcoreUltrahuman: 'gid://shopify/ProductVariant/42729160278112',
};

export const productMap_photon = {
  id: 'photon',
  name: 'Ultrahuman Photon',
  SKU: 'PHOTON-BASE-01',
  variantId: {
    [ShopifyStore.IN]: VARIANTS.ultrahumanStore,
    [ShopifyStore.ROW]: VARIANTS.ultrahumanUS,
    [ShopifyStore.US]: VARIANTS.stelcoreUltrahuman,
    [ShopifyStore.CA]: VARIANTS.stelcoreUltrahuman,
    [ShopifyStore.AE]: VARIANTS.ultrahumanUae,
    [ShopifyStore.EU]: VARIANTS.ultrahumanEuUk,
    [ShopifyStore.GB]: VARIANTS.ultrahumanEuUk,
    [ShopifyStore.AU]: VARIANTS.ultrahumanEuUk,
    [ShopifyStore.SA]: VARIANTS.ultrahumanEuUk,
    [ShopifyStore.MX]: VARIANTS.ultrahumanEuUk,
    [ShopifyStore.ZA]: VARIANTS.ultrahumanEuUk,
    [ShopifyStore.JP]: VARIANTS.ultrahumanEuUk,
  },
  taxesInclusion: {
    [ShopifyStore.IN]: true,
    [ShopifyStore.ROW]: false,
    [ShopifyStore.US]: false,
    [ShopifyStore.EU]: true,
    [ShopifyStore.GB]: true,
    [ShopifyStore.AE]: false,
    [ShopifyStore.AU]: true,
    [ShopifyStore.CA]: false,
    [ShopifyStore.SA]: true,
    [ShopifyStore.MX]: true,
    [ShopifyStore.ZA]: true,
    [ShopifyStore.JP]: true,
  },
} as const;

export const PhotonCarouselItems: ProductCarouselItem[] = [
  {
    videoSrc: getCompressedAssetUrl('/web_v2/photon/carousel/desktop-1/1.mp4'),
    videoSrcResponsive: getCompressedAssetUrl(
      '/web_v2/photon/carousel/mobile-1/1.mp4',
    ),
    alt: 'Ultrahuman Photon device',
    objectFit: 'cover',
    background: '#f3f4f6',
    // title: 'Twelve LEDs.',
    // description: 'Targeted recovery from skin to deep tissue',
  },
  {
    src: 'web_v2/photon/carousel/desktop-1/2.png',
    srcResponsive: 'web_v2/photon/carousel/mobile-1/2.png',
    alt: 'Ultrahuman Photon device',
    objectFit: 'cover',
    background: '#f3f4f6',
  },
  {
    src: 'web_v2/photon/carousel/desktop-1/3.png',
    srcResponsive: 'web_v2/photon/carousel/mobile-1/3.png',
    alt: 'Ultrahuman Photon device',
    objectFit: 'cover',
    background: '#f3f4f6',
  },
  {
    src: 'web_v2/photon/carousel/desktop-1/4..png',
    srcResponsive: 'web_v2/photon/carousel/mobile-1/4.png',
    alt: 'Ultrahuman Photon device',
    objectFit: 'cover',
    background: '#f3f4f6',
  },
  {
    src: 'web_v2/photon/carousel/desktop-1/5-1.png',
    srcResponsive: 'web_v2/photon/carousel/mobile-1/5-1.png',
    alt: 'Ultrahuman Photon device',
    objectFit: 'cover',
    background: '#f3f4f6',
  },
  {
    src: 'web_v2/photon/carousel/desktop-1/6-1.png',
    srcResponsive: 'web_v2/photon/carousel/mobile-1/6-1.png',
    alt: 'Ultrahuman Photon device',
    objectFit: 'cover',
    background: '#f3f4f6',
  },
  {
    /* Powerplug mockup — final shot. */
    src: 'web_v2/photon/carousel/desktop-1/7-4.png',
    srcResponsive: 'web_v2/photon/carousel/mobile-1/7-4.png',
    alt: 'Ultrahuman Photon Protocol PowerPlug app screens',
    objectFit: 'cover',
    background: '#f3f4f6',
  },
];

export const photonCards: CardConfig[] = [];
